import { Injectable } from '@angular/core';
import { IonicSafeString, ToastButton, ToastController } from '@ionic/angular';
import { Color } from '@ionic/core';

@Injectable({
  providedIn: 'root',
})
export class ToastService {
  constructor(private toastController: ToastController) {}

  /**
   * Shows a toast message
   *
   * @param {string} [header]
   * @param {(string | IonicSafeString)} [message]
   * @param {(string | string[])} [cssClass]
   * @param {number} [duration]
   * @param {((ToastButton | string)[])} [buttons]
   * @param {('top' | 'bottom' | 'middle')} [position]
   * @param {string} [icon]
   * @param {('primary'
   *       | 'secondary'
   *       | 'tertiary'
   *       | 'success'
   *       | 'warning'
   *       | 'danger'
   *       | 'light'
   *       | 'medium'
   *       | 'dark')} [color]
   * @return {*}  The role of the button that was clicked
   * @memberof ToastService
   */
  public async presentToastWithOptions(
    header?: string,
    message?: string | IonicSafeString,
    cssClass?: string | string[],
    duration?: number,
    buttons?: (ToastButton | string)[],
    position?: 'top' | 'bottom' | 'middle',
    icon?: string,
    color?:
      | 'primary'
      | 'secondary'
      | 'tertiary'
      | 'success'
      | 'warning'
      | 'danger'
      | 'light'
      | 'medium'
      | 'dark'
  ): Promise<string> {
    const toast = await this.toastController.create({
      header: header,
      message: message,
      icon: icon,
      position: position || 'bottom',
      buttons: buttons,
      cssClass: cssClass,
      duration: duration || 2000,
      color: color,
    });

    await toast.present();

    const { role } = await toast.onDidDismiss();

    return role;
  }
}
